import React from "react";
import "./opportunities.css";
import InvestmentCalculator from "./calculator";
import {Link} from "react-router-dom"

const InvestmentsPage = () => {
  const investments = [
    {
      name: "Agriculture Investment",
      image: "https://images.unsplash.com/photo-1501004318641-b39e6451bec6?auto=format&fit=crop&w=800&q=80",
      duration: "13 Months",
      commission: "20% from profits",
      investorShare: "80% profits",
      minInvestment: "₹ 50,000",
      features: [
        "High growth potential in organic farming",
        "Sustainable long-term returns",
        "Direct tie-ups with farmers",
      ],
    },
    {
      name: "Real Estate Investment",
      image: "https://i.imgur.com/fkscNIU.png",
      duration: "13 Months",
      commission: "20% from profits",
      investorShare: "80% profits",
      minInvestment: "₹ 50,000",
      features: [
        "Premium plots & commercial properties",
        "Capital appreciation + rental yield",
        "Fully managed investment",
      ],
    },
    {
      name: "Dairy Farm Investment",
      image: "https://i.imgur.com/Khsra4U.jpeg",
      duration: "13 Months",
      commission: "20% from profits",
      investorShare: "80% profits",
      minInvestment: "₹ 50,000",
      features: [
        "Modern dairy automation system",
        "Monthly profit distribution",
        "Government-supported sector",
      ],
    },
    {
      name: "Gold Investment",
      image: "https://i.imgur.com/vvws7Hq.png",
      duration: "13 Months",
      commission: "20% from profits",
      investorShare: "80% profits",
      minInvestment: "₹ 50,000",
      features: [
        "Safe and stable returns",
        "Backed by physical gold assets",
        "High liquidity investment",
      ],
    },
  ];

  const processSteps = [
    { step: "Step 1", title: "Initial Consultation", desc: "Discuss your investment goals and risk appetite with our experts." },
    { step: "Step 2", title: "Investment Selection", desc: "Choose the most suitable investment plan based on your preferences." },
    { step: "Step 3", title: "Documentation", desc: "Complete secure digital paperwork to start your investment journey." },
    { step: "Step 4", title: "Investment Monitoring", desc: "Track your investment performance through our smart dashboard." },
    { step: "Step 5", title: "Returns Distribution", desc: "Receive your profit share directly in your bank account as scheduled." },
  ];

  const reasons = [
    {
      title: "Trusted Expertise",
      text: "10+ years of experience in diversified investment management.",
    },
    {
      title: "Secure & Transparent",
      text: "Every transaction is digitally verified and trackable in real-time.",
    },
    {
      title: "Consistent ROI",
      text: "Achieving average annualized returns between 30%-45%.",
      link:"terms and Conditions"
    },
    {
      title: "Dedicated Support",
      text: "24/7 support from professional investment advisors.",
    },
  ];

  return (
    <div className="investment-page">
      {/* Header */}
      <header className="investment-header">
        <h1>Explore Our Investment Opportunities</h1>
        <p>Grow your wealth through secure, sustainable, and profitable ventures.</p>
      </header>

      {/* Investment Cards */}
      <section className="investment-cards">
        {investments.map((inv, index) => (
          <div key={index} className="investment-card">
            <img src={inv.image} alt={inv.name} className="investment-image" />
            <div className="card-content">
              <h2>{inv.name}</h2>
              <div className="investment-details">
                <p><strong>Duration:</strong> {inv.duration}</p>
                <p><strong>Commission:</strong> {inv.commission}</p>
                <p><strong>Investor Receives:</strong> {inv.investorShare}</p>
                <p><strong>Minimum Investment:</strong> {inv.minInvestment}</p>
              </div>
              <ul className="features">
                {inv.features.map((f, i) => (
                  <li key={i}>• {f}</li>
                ))}
              </ul>
              <button className="invest-btn">Invest Now</button>
            </div>
          </div>
        ))}
      </section>

      {/* Investment Process */}
      <section className="process-section">
        <h2>Our Investment Process</h2>
        <div className="process-flow">
          {processSteps.map((step, i) => (
            <div key={i} className="process-card flow-animate">
              <h3>{step.step}</h3>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
              {i < processSteps.length - 1 && <div className="flow-line"></div>}
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-section">
        <h2>Why Choose Us?</h2>
        <div className="why-cards">
          {reasons.map((r, i) => (
            <div key={i} className="why-card">
              <h3>{r.title}</h3>
              <p>{r.text}</p>
            </div>
          ))}
        </div>
      </section>
      <div className="cal">
        <InvestmentCalculator/>
      </div>
      <div class="sp1">
                <Link to="/"><button className="backk">Back</button></Link>
                </div>
    </div>
  );
};

export default InvestmentsPage;
